import * as classes from "./plant-modal.module.scss";
import { plants } from "../../images";

import content from "../../content.json";
import PlantPowerMeter from "./PlantPowerMeter";
import PictureNiceLoader from "../PictureNiceLoader/PictureNiceLoader";
import { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";
import { useCallback } from "react";

export const useAnimate = () => {
  const raf = useRef<number>();
  const rotTarget = useRef({ x: 0, y: 0 });
  const rotCurrent = useRef({ x: 0, y: 0 });

  const [rotXCurrent, setRotXCurrent] = useState(0);
  const [rotYCurrent, setRotYCurrent] = useState(0);

  const now = useRef(Date.now());
  const then = useRef(Date.now());

  const animate = useCallback(() => {
    now.current = Date.now();
    const delta = now.current - then.current;
    const correction = delta / 16.66;

    rotCurrent.current.x +=
      (rotTarget.current.x - rotCurrent.current.x) * 0.05 * correction;
    rotCurrent.current.y +=
      (rotTarget.current.y - rotCurrent.current.y) * 0.05 * correction;

    setRotXCurrent(rotCurrent.current.x);
    setRotYCurrent(rotCurrent.current.y);

    then.current = now.current;
    raf.current = requestAnimationFrame(animate);
  }, []);

  useEffect(() => {
    const onMouseMove = ({ clientX, clientY }) => {
      const x = (clientX / window.innerWidth) * 2 - 1;
      const y = (clientY / window.innerHeight) * 2 - 1;
      const rotX = y * 7;
      const rotY = x * 11;

      rotTarget.current.x = rotX * -1;
      rotTarget.current.y = rotY;
    };

    window.addEventListener("mousemove", onMouseMove);

    raf.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(raf.current);
      window.removeEventListener("mousemove", onMouseMove);
    };
  }, []);

  return [rotXCurrent, rotYCurrent];
};

const PlantModal = ({ name }: { name: string }) => {
  const data = content.rarePlants[name];
  const { name: displayName, bodyCopy } = data;
  const [rotXCurrent, rotYCurrent] = useAnimate();

  return (
    <div
      className={classes.root}
      style={{
        transform: `rotateX(${rotXCurrent}deg) rotateY(${rotYCurrent}deg)`,
      }}
    >
      <PlantPowerMeter />
      <div className={classes["image-wrapper"]}>
        <PictureNiceLoader
          className={classes.image}
          alt={`Preview of look ${displayName}`}
          src={plants[name].src}
          sources={[
            { srcSet: plants[name].srcSet.png, type: "image/png" },
            { srcSet: plants[name].srcSet.webp, type: "image/webp" },
          ]}
          sizes="(min-width: 769px) 25vw, 90vw"
        />
        <h2 className={classes.heading}>
          <span className={classes["heading__intro"]}>You discovered</span>
          <br />
          <span className={classes["heading__name"]}>{displayName}</span>
        </h2>
      </div>
      <p
        className={classes.body}
        dangerouslySetInnerHTML={{ __html: bodyCopy }}
      ></p>
    </div>
  );
};

export default PlantModal;
